/** El dashboard y pedido-entregados esperan un array de filas de resumen. */
export function toLegacyResumenDespachoArray(raw: unknown): unknown[] {
  if (Array.isArray(raw)) {
    return raw;
  }
  if (!raw || typeof raw !== 'object') {
    return [];
  }
  const r = raw as Record<string, unknown>;
  const candidates = [r['datos'], r['data'], r['items'], r['rows']];
  for (const c of candidates) {
    if (Array.isArray(c)) {
      return c;
    }
  }
  return [];
}

/** Lista plana para `NotificacionService.groupNotifications`. */
export function toNotificacionesList(raw: unknown): unknown[] {
  if (Array.isArray(raw)) {
    return raw;
  }
  if (!raw || typeof raw !== 'object') {
    return [];
  }
  const r = raw as Record<string, unknown>;
  const candidates = [r['datos'], r['data'], r['items'], r['notificaciones']];
  for (const c of candidates) {
    if (Array.isArray(c)) {
      return c;
    }
  }
  return [];
}
